import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge";
import TicketRequest from "../../magData/Train/TicketRequest";
import TicketResponse from "../../magData/Train/TicketResponse";

function TrainTicketPage(props) {
  return (
    <>
      <Container fluid>
        <Row>
          <Col sm={12}>
            <p className="page-title">Train Ticket Method</p>
          </Col>
          <Col sm={12}>
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/Train/ticket</p>
          </Col>
          <Col sm={12}>
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <p>Body Parameters</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Request Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(TicketRequest, null, 2)}
            </pre>
          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12}>
            <p>Response Information</p>
          </Col>





          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                <tr>
                                  <td>NetRate</td>
                                  <td>
                                    <p>Net Rate</p>
                                  </td>
                                  <td>
                                    decimal number
                                  </td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Currency</td>
                                  <td>
                                    <p>Currency</p>
                                  </td>
                                  <td>
                                    string
                                  </td>
                                  <td>
                                    <p>None.</p>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={4}>
                                    <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>ArrivalDateTime</td>
                                          <td>
                                            <p>Arrival Date and Time</p>
                                          </td>
                                          <td>
                                            date
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>DepartureDateTime</td>
                                          <td>
                                            <p>Departure Date and Time</p>
                                          </td>
                                          <td>
                                            date
                                          </td>
                                          <td>
                                            <p>Required</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>JourneyDurationPerMinute</td>
                                          <td>
                                            <p>Journey Duration Per Minute</p>
                                          </td>
                                          <td>
                                            integer
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan={4}>
                                            <Table bordered>
                                              <tbody>
                                                <tr>
                                                  <td>ResBookDesigCode</td>
                                                  <td>
                                                    <p></p>
                                                  </td>
                                                  <td>
                                                    string
                                                  </td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>StopQuantity</td>
                                                  <td>
                                                    <p></p>
                                                  </td>
                                                  <td>
                                                    integer
                                                  </td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>Baggage</td>
                                                  <td>
                                                    <p></p>
                                                  </td>
                                                  <td>
                                                    string
                                                  </td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td>Class</td>
                                                  <td>
                                                    <p></p>
                                                  </td>
                                                  <td>
                                                    string
                                                  </td>
                                                  <td>
                                                    <p>None.</p>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </Table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Response Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(TicketResponse, null, 2)}
            </pre>
          </Col>
        </Row>
      </Container>
    </>
  );
}
export default TrainTicketPage;
